import {dateTimeOptions} from '../../../settings/humanum';

export const localizedTime = function (date: number, lang?: string): string {
    return new Date(date * 1000).toLocaleTimeString(lang ? lang : navigator.language, dateTimeOptions);
};